// extracted by mini-css-extract-plugin
export default {"root":"inventory_page_root__FvyBE"};